import { FEATURE_FLAG_KEYS } from '@/features/open-feature'
import { useStringFlagValue } from '@openfeature/react-sdk'

export enum CaseStyle {
  upperCase = 'upper_case',
  lowerCase = 'lower_case',
  titleCase = 'title_case',
}

const LAUNCH_DARKLY_THERAPIST_FALLBACK_VALUE = 'therapist'

const applyCaseStyle = (source: string, caseStyle: CaseStyle): string => {
  if (!source) return source

  switch (caseStyle) {
    case CaseStyle.upperCase:
      return source.toUpperCase()
    case CaseStyle.lowerCase:
      return source.toLowerCase()
    case CaseStyle.titleCase:
      return source.charAt(0).toUpperCase() + source.slice(1).toLowerCase()
    default:
      return source
  }
}

const isAlreadyPlural = (value: string): boolean => {
  return value.toLowerCase().endsWith('s')
}

export const useTherapistFlag = (
  caseStyle: CaseStyle,
  isPlural: boolean = false
): string => {
  const ffValue = useStringFlagValue(
    FEATURE_FLAG_KEYS.replaceTherapistVariable,
    LAUNCH_DARKLY_THERAPIST_FALLBACK_VALUE
  )
  const styledValue = applyCaseStyle(ffValue, caseStyle)

  if (isPlural && !isAlreadyPlural(styledValue)) {
    return `${styledValue}s`
  }
  return styledValue
}
